import { resolveIconHref } from "../../../../features/icons/resolve-icon.js";
/** biome-ignore-all lint/security/noDangerouslySetInnerHtml: Renders rich text authored in the CMS. */
import type {
	AlertUmbBlockElementModel,
	AlertUmbBlockSettingsElementModel,
} from "#/_generated/umbraco/delivery-api/models";
import { Alert } from "#/_packages/umbrella/features/alerts/components/alert.tsx";
import type { BlockItemProps } from "#/_packages/umbrella/integrations/umbraco/types";
import { tryGetIntent } from "#/_packages/umbrella/utils";

type AlertBlockProps = BlockItemProps & {
	content: AlertUmbBlockElementModel;
	settings?: AlertUmbBlockSettingsElementModel;
	fullWidth?: boolean;
	onDismiss?: () => void;
	dismissLabel?: string;
};

export default function AlertUmbBlock({
	className,
	content,
	settings,
	fullWidth,
	onDismiss,
	dismissLabel,
}: AlertBlockProps) {
	return (
		<Alert
			id={settings?.properties?.generatedId ?? `alert-${content.id}`}
			className={className}
			fullWidth={fullWidth}
			onDismiss={onDismiss}
			dismissLabel={dismissLabel}
			intent={tryGetIntent(content.properties?.intentColor)}
			icon={
				content.properties?.icon ? (
					<svg className="icon" aria-hidden="true">
						<use
							href={resolveIconHref(content.properties.icon)}
						/>
					</svg>
				) : undefined
			}
			closeButton={content.properties?.closeButton ?? false}
		>
			{content.properties?.message?.markup ? (
				<div
					className="rich-text [&>:last-child]:mb-0"
					dangerouslySetInnerHTML={{
						__html: content.properties.message.markup,
					}}
				/>
			) : null}
		</Alert>
	);
}
